import gql from "graphql-tag";

const REMOVE_FAVORITE = gql`
  mutation removeFavorite($customer: String!) {
    removeFavorite(customer: $customer)
  }
`;

export default REMOVE_FAVORITE;
